import { makeStyles } from 'tss-react/mui';

import { SliderVariant } from '@constants/common/ui.constants';

const useStyles = makeStyles<{ variant: SliderVariant }>()(
  (theme, { variant }) => ({
    sliderWrap: {
      padding: '12px 0',
      marginBottom: 10,

      '& .MuiSlider-valueLabel': {
        lineHeight: 1.2,
        padding: 0,
        width: 42,
        height: 32,
        fontSize: '14px',
        fontWeight: 600,

        ...(variant === SliderVariant.Primary && {
          background: theme.primary.p3,
        }),

        ...(variant === SliderVariant.Warning && {
          background: theme.accent.a4,
        }),
      },

      '& .MuiSlider-mark': {
        display: 'none',
      },

      '& .MuiSlider-rail': {
        height: '4px',
        borderRadius: theme.borderRadius.xxl,
        background: theme.secondary.s2,
        padding: '0px',
      },

      '& .MuiSlider-thumb::after': {
        width: '20px',
        height: '20px',
        opacity: 1,

        ...(variant === SliderVariant.Primary && {
          background: theme.primary.p3,
        }),

        ...(variant === SliderVariant.Warning && {
          background: theme.accent.a4,
        }),
      },
      '& .MuiSlider-track': {
        border: 'none',
        height: '4px',

        ...(variant === SliderVariant.Primary && {
          background: theme.primary.p3,
        }),

        ...(variant === SliderVariant.Warning && {
          background: theme.accent.a4,
        }),
      },
      '& .MuiSlider-markLabel': {
        fontWeight: 300,
        color: theme.secondary.s3,
        fontSize: '14px',
        top: '30px',
      },
    },
    disabled: {
      opacity: 0.38,
      cursor: 'default',
    },
  }),
);

export default useStyles;
